import React, { useEffect } from 'react';
import classnames from 'classnames';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  responsivePadding: {
    padding: '56.25% 0 0 0',
    position: 'relative'
  },
  responsiveWrapper: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  embed: {
    width: '100%',
    height: '100%'
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}));

declare global {
  interface Window {
    _wq: any;
  }
}
interface IWistiaPlayerProps {
  hashedId: string
  [x:string]: any
}

const WistiaPlayer = ({ hashedId, ...embedOptions }: IWistiaPlayerProps) => {
  const classes = useStyles();

  useEffect(() => {
    window._wq = window._wq || [];
    window._wq.push({
      id: hashedId,
      options: embedOptions
    });
  }, [hashedId, embedOptions]);

  useEffect(() => {
    if (!document.getElementById('wistia_script')) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = 'wistia_script';
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.body.appendChild(wistiaScript);
    }
  }, []);

  return (
    <div className={classes.responsivePadding}>
      <div className={classes.responsiveWrapper}>
        <div className={classnames(`wistia_embed wistia_async_${hashedId} videoFoam=true`, classes.embed)}>
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WistiaPlayer;
